const Line = props => (
    <svg width={110} height={1} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path stroke="#000" d="M0 .5h110" />
    </svg>
)

export default Line
